import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'bp_filters';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SemFiltersPage')), {
  delay: 500
});